import pageTable from './pageTable.vue'

export default pageTable
